import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import loginimage from "../../../Assets/Team/login-imagee.png";
import loginimage2 from "../../../Assets/Team/login-light-image.png";
import item3 from "../../../Assets/login/item3.svg";
import { useLocation } from "react-router-dom";

import axios from "../../../axiosInstance.js";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { tokenState, userIdState, typeState } from "../../../Auth/Atoms.jsx";
import "./LoginPage2.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Input } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import encrypt from "../../../Services/Encryption/Encyption.js";
import { login } from "./authSlice";
import Navbar from "../../../Component/Home/Navbar.jsx";
import Footer from "../../../Component/Home/footer/Footer.jsx";

// import Loader from '../../../Component/Loader.jsx'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalBox from "../../../Component/ModalBox/ModalBox.jsx";
import { useModal } from "../../../context/ModalContext.jsx";
import { validateToken } from "../../../Auth/authUtils.js";
import ZohoTest from "../../../Component/ZohoTest.jsx";
import {
  ArrowRight,
  CheckCircle2,
  Clock3,
  Headphones,
  Moon,
  Phone,
  ShieldCheck,
  Sun,
  Truck,
  Wrench,
  Construction,
  LifeBuoy,
} from "lucide-react";

// Hero copy — cycles between Hindi and English every few seconds
const HERO_TEXT = {
  hi: {
    titleLine1: "दुर्घटना से",
    titleLine2: "समाधान तक",
    subtitleLine1: "आपके वाहन के साथ,",
    subtitleLine2: "हर कदम पर।",
  },
  en: {
    titleLine1: "From accident",
    titleLine2: "to resolution",
    subtitleLine1: "With your vehicle,",
    subtitleLine2: "every step of the way.",
  },
};

const HERO_SWITCH_INTERVAL_MS = 3500;

function Login() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const [loading, setLoading] = useState(true);
  const [alertInfo, setAlertInfo] = useState({
    show: false,
    message: "",
    severity: "info",
  });
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(null);

  const [otp, setOtp] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);
  const [userId, setUserId] = useRecoilState(userIdState);
  const [typeOf, setTypeOf] = useRecoilState(typeState);
  const [showPassword, setShowPassword] = useState(false);
  const [fontSize, setFontSize] = useState("35px");
  const [emailError, setEmailError] = useState("");
  let [passwordError, setPasswordError] = useState("");

  // Hero language toggle (Hindi <-> English)
  const [showEnglish, setShowEnglish] = useState(false);
  const activeHero = showEnglish ? HERO_TEXT.en : HERO_TEXT.hi;

  useEffect(() => {
    const interval = setInterval(() => {
      setShowEnglish((prev) => !prev);
    }, HERO_SWITCH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const publicVapidKey =
    "BI0sWPKFjmxnkWYcwjylL7qmo9svTNzEyuEG8-xyswDkQ_FKbONR1yQ6CAUZ9EsryyJiQATfDUZnfloTn8z9DS0";

  const dispatch = useDispatch();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  useEffect(() => {
    const checkLogin = async () => {
      const isValid = await validateToken();
      const userRole = localStorage.getItem("userRole");
      const currentStep = localStorage.getItem("currentStep");

      if (isValid) {
        if (userRole === "crane") {
          navigate("/crane-driver-home", { replace: true });
        } else if (userRole === "customer") {
          navigate("/customer-home-page", { replace: true });
        } else if (userRole === "recoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        } else if (userRole === "craneandrecoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        } else if (userRole === "vendorDriver") {
          navigate("/vendor-driver-home", { replace: true });
        } else if (
          ["Management", "IT", "Operations", "HR", "KAM"].includes(userRole)
        ) {
          navigate("/admin-dashboard-vendor-customer", { replace: true });
        } else {
          navigate("/loginPage", { replace: true });
        }
      } else {
        setIsCheckingAuth(false); // show login form only if not logged in
      }
    };

    checkLogin();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 360) {
        setFontSize("20px");
      } else {
        setFontSize("30px");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    const rememberMeFlag = localStorage.getItem("rememberMe") === "true";

    if (savedEmail && rememberMeFlag) {
      setEmail(savedEmail);
      // setOtp(savedPassword);
      setRememberMe(rememberMeFlag);
    }
  }, []);

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhone(validatePhoneNumber(newPhone));
    if (e.target.value.trim() !== "") {
      setHasError(false);
    }

    if (!showLoginBtn) {
      setShowLoginBtn(true);
    }

    if (modalData.isOpen) {
      closeModal();
    }
  };

  const validatePhoneNumber = (value) => {
    let updatedValue = value.replace(/\D/g, ""); // Remove non-digit characters
    if (updatedValue && updatedValue[0].match(/[6-9]/)) {
      updatedValue = updatedValue.slice(0, 10); // Only keep up to 10 digits if it starts with 6-9
    } else {
      updatedValue = ""; // Return an empty string if the first digit isn't between 6-9
    }
    return updatedValue;
  };

  const handleOtpChange = (e) => {
    // Allow only numbers and limit to 6 digits
    if (/^\d{0,6}$/.test(e.target.value)) {
      setOtp(e.target.value);
    }
    // setOtp(e.target.value);

    if (modalData.isOpen) {
      closeModal();
    }
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);
  };

  const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  };

  const sendLoginNotification = async (getUserId, getToken) => {
    try {
      console.log("Registering service worker...");
      const registration =
        await navigator.serviceWorker.register("/service-worker.js");
      console.log("Service worker registered:", registration);

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
      });
      console.log("Push Manager subscription:", subscription);

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/subscription/${getUserId}`,
        subscription,
        { headers: { Authorization: `Bearer ${getToken}` } },
      );
    } catch (error) {
      console.error("Error sending login notification:", error);
    }
  };

  const [loginData, setLoginData] = useState({});
  const [showLoginBtn, setShowLoginBtn] = useState(true);
  const [otpForTemp, setOtpForTemp] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const showSuccessToast = (e) => {
    toast.success(e);
  };

  const showErrorToast = (e) => {
    toast.error(e);
  };

  const validatePhone = (phone) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(phone);
  };

  const getOtp = async (e) => {
    try {
      e.preventDefault();

      setHasError(false);
      setOtpHasError(false);
      setErrorInputName(null);

      setOtp("");

      if (!validatePhone(phone)) {
        setHasError(true);

        setErrorInputName("phone");
        openModal({
          title: "Error",
          body: "Please enter valid phone Number",
          iconType: "error",
          autoClose: true,
        });
        return;
      }

      // setPhoneError(null)

      const encryptedPhone = await encrypt(phone);
      // return

      setIsLoading(true);
      let response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/generateOtpAndSend`,
        {
          phoneNumber: encryptedPhone.encryptedData,
          phoneNumberIv: encryptedPhone.iv,
        },
      );

      console.log("OTP Response: ");
      console.log(response);

      if (!response || !response.data.otp) {
        // showErrorToast('OTP error occurred!')
        openModal({
          title: "Error",
          body: "OTP error occurred!",
          iconType: "error",
          autoClose: true,
        });
        console.log("OTP is missing from Get OTP Response Method");
        return;
      }

      // showSuccessToast('OTP generated and sent successfully!')
      openModal({
        title: "Success",
        body: "OTP sent successfully",
        iconType: "success",
        autoClose: true,
      });

      setTimeout(() => {
        otpInput.current?.focus();
      }, 1000);

      setShowLoginBtn(false);
      // TODO: Comment this line when OTP autofill is not required
      // setOtp(response.data.otp)
      if (response.data?.tempAccount == true) {
        setOtpForTemp(true);
      }

      const otpSent = true;
      if (otpSent) {
        setTimeLeft(120);
      }

      setOTPList([...optList, response.data.otp]);
    } catch (error) {
      console.log("Error occurred: ", error);
      console.log(error.response.data);
      setHasError(true);
      setErrorInputName("phone");

      if (
        error?.response?.data?.message ===
        "Phone number is not registered with us"
      ) {
        openModal({
          title: "Error",
          body: "Phone number is not registered. Please click below to sign up",
          iconType: "error",
          autoClose: false,
          actionLabel: "Sign Up",
          onAction: () => {
            localStorage.setItem("newNumber", phone);
            navigate("/SignUp");
            closeModal();
          },
        });
        return;
      }
      openModal({
        title: "Error",
        body: error.response.data.message || "Internal server error occurred!",
        iconType: "error",
        autoClose: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    console.log("handleSubmit calling: ");

    try {
      e.preventDefault();
      if (modalData.isOpen) {
        closeModal();
        return;
      }

      const found = optList.includes(otp.trim());

      console.log(optList);
      console.log("OTP found: ===================== ");
      console.log(found);

      if (showRetry && found) {
        openModal({
          title: "Error",
          body: "OTP has expired. Please click on resend OTP to get new OTP",
          iconType: "error",
          autoClose: true,
        });
        return;
      }

      setHasError(false);
      setOtpHasError(false);
      setErrorInputName(null);
      closeModal();

      if (!validatePhone(phone)) {
        setHasError(true);

        setErrorInputName("phone");
        openModal({
          title: "Error",
          body: "Please enter valid phone Number",
          iconType: "error",
          autoClose: true,
        });
        return;
      }

      if (otp === "") {
        // setPhoneError('Mobile Number is required')
        setOtpHasError(true);
        setErrorInputName("otp");
        openModal({
          title: "Error",
          body: "Please provide OTP number",
          iconType: "error",
          autoClose: true,
        });
        return;
      }

      setIsLoading(true);

      const encryptedPhone = await encrypt(phone);
      const encryptedOtp = await encrypt(otp);

      let obj = {
        phoneNumber: encryptedPhone.encryptedData,
        phoneNumberIv: encryptedPhone.iv,
        otp: encryptedOtp.encryptedData,
        otpIv: encryptedOtp.iv,
      };

      // console.log('obj ', obj)

      console.log("Login Response: ");
      let response = null;
      const url =
        otpForTemp == true
          ? `${process.env.REACT_APP_BACKEND_URL}/api/loginForTempAccount`
          : `${process.env.REACT_APP_BACKEND_URL}/api/login`;

      try {
        response = await axios.post(url, {
          phoneNumber: encryptedPhone.encryptedData,
          phoneNumberIv: encryptedPhone.iv,
          otp: encryptedOtp.encryptedData,
          otpIv: encryptedOtp.iv,
        });
      } catch (error) {
        console.log(error);

        console.log(error.message);

        if (error.message.toLowerCase() === "network error") {
          openModal({
            title: "Error",
            body: error.message,
            iconType: "error",
            autoClose: true,
          });
          return;
        }

        console.log(error?.response?.data?.message.toLowerCase());

        let msg = error?.response?.data?.message?.toLowerCase();

        if (msg.includes("phone")) {
          setErrorInputName("phone");
          setHasError(true);
          // setOtpHasError(false)
        }
        if (msg.includes("otp")) {
          setErrorInputName("otp");
          // setPhoneError(false)
          setOtpHasError(true);

          if (msg === "incorrect otp.") {
            openModal({
              title: "Error",
              body: "Incorrect OTP number",
              iconType: "error",
              autoClose: true,
            });
          }
          return;
        }

        openModal({
          title: "Error",
          body: msg || error.message,
          iconType: "error",
          autoClose: true,
        });

        // otpInput?.current?.focus()
        return;
      }

      console.log(response);

      // return

      if (response.status === 200) {
        console.log("userType", response.data.data.userType);

        const dept = response.data.data.department?.trim();
        const normalizedDept = dept?.toLowerCase();
        if (
          response.data.data?.userType === "admin" ||
          ["management", "it", "operations", "hr", "kam"].includes(
            normalizedDept,
          )
        ) {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", dept || "Management");
          navigate("../admin-dashboard-vendor-customer");
        } else if (response.data.data.vendorType === "advocate") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "advocate");
          navigate("../advocateDashboard");
        } else if (response.data.data.vendorType === "mechanic") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "mechanic");
          navigate("../MechanicDashboard");
        } else if (response.data.data.vendorType === "crane") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "crane");
          localStorage.setItem("phoneNumber", obj.phoneNumber);
          localStorage.setItem("phoneNumberIv", obj.phoneNumberIv);
          localStorage.setItem("otp", obj.otp);
          localStorage.setItem("otpIv", obj.otpIv);
          localStorage.setItem("vendorPhone", response.data.data.vendorPhone);
          localStorage.setItem("vendorName", response.data.data.vendorName);

          navigate("/crane-driver-home");
        } else if (response.data.data.vendorType === "recoveryVan") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "recoveryVan");
          localStorage.setItem("phoneNumber", obj.phoneNumber);
          localStorage.setItem("phoneNumberIv", obj.phoneNumberIv);
          localStorage.setItem("otp", obj.otp);
          localStorage.setItem("otpIv", obj.otpIv);
          localStorage.setItem("vendorPhone", response.data.data.vendorPhone);
          localStorage.setItem("vendorName", response.data.data.vendorName);

          navigate("/crane-driver-home");
        } else if (response.data.data.vendorType === "craneandrecoveryVan") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "craneandrecoveryVan");
          localStorage.setItem("phoneNumber", obj.phoneNumber);
          localStorage.setItem("phoneNumberIv", obj.phoneNumberIv);
          localStorage.setItem("otp", obj.otp);
          localStorage.setItem("otpIv", obj.otpIv);
          localStorage.setItem("vendorPhone", response.data.data.vendorPhone);
          localStorage.setItem("vendorName", response.data.data.vendorName);

          navigate("/crane-driver-home");
        } else if (response.data.data.vendorType === "workshop") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "workshop");
          localStorage.setItem("phoneNumber", obj.phoneNumber);
          localStorage.setItem("phoneNumberIv", obj.phoneNumberIv);
          localStorage.setItem("otp", obj.otp);
          localStorage.setItem("otpIv", obj.otpIv);
        } else if (response.data.data.department === "Administration") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "Administration");
          navigate("../Admin");
        } else if (
          ["Insurance", "Legal"].includes(response.data.data.department)
        ) {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", response.data.data.department);
          navigate("../admin-dashboard-vendor-customer");
        } else if (response.data.data.department === "Sales") {
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "sales");
          navigate("../Salesteam");
        } else if (response.data.data.customerDriverCode) {
          setupCommonLoginDetails(response);
          console.log("userRole", "customerDriver");
          localStorage.setItem("userRole", "customerDriver");
          navigate("../customer-home-page");
        } else if (response.data.data.vendorDriverCode) {
          if (response?.data?.data?.isActive === 0) {
            openModal({
              title: "Error",
              body: "Login not allowed",
              iconType: "error",
              autoClose: true,
            });
            return;
          }
          setupCommonLoginDetails(response);
          console.log("userRole", "vendorDriver");
          localStorage.setItem("userRole", "vendorDriver");
          localStorage.setItem("userType", response.data.data.VendorType);
          navigate("../vendor-driver-home");
        } else {
          // For customer
          setupCommonLoginDetails(response);
          localStorage.setItem("userRole", "customer");
          localStorage.setItem("fromLogin", true);
          localStorage.setItem("justLoggedIn", "true");
          navigate("../customer-home-page");
        }
      } else {
        openModal({
          title: "Error",
          body: "Internal server error",
          iconType: "error",
          autoClose: true,
        });
      }
    } catch (error) {
      openModal({
        title: "Error",
        body: error?.message,
        iconType: "error",
        autoClose: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const setupCommonLoginDetails = (response) => {
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("userId", response.data.userId);
    localStorage.setItem("loginId", response.data.loginId);
    localStorage.setItem("loginTime", Date.now());
    document.cookie = `token=${response.data.token}; path=/; max-age=${
      48 * 60 * 60
    }; secure; samesite=strict`;

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "userId",
          userId: response.data.userId,
        }),
      );
    }
    if (response.data?.data.department) {
      localStorage.setItem("department", response.data.data.department);
    }
    setToken(response.data.token);
    setUserId(response.data.userId);
    setTypeOf(
      response.data.data.department ? response.data.data.department : "",
    );
    dispatch(login({ userId, token }));
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
      localStorage.setItem("rememberedPassword", otp);
      localStorage.setItem("rememberMe", true);
    } else {
      localStorage.removeItem("rememberedaEmail");
      localStorage.removeItem("rememberedPassword");
      localStorage.removeItem("rememberMe");
    }

    setAlertInfo({
      show: true,
      messageAdvocate: response.data.message,
      severity: "success",
    });

    sendLoginNotification(response.data.userId, response.data.token);
  };

  const btnGetOtp = useRef(null);
  const btnLogin = useRef(null);

  const { openModal, modalData, closeModal } = useModal();

  const [hasError, setHasError] = useState(false);
  const [hasOtpError, setOtpHasError] = useState(false);

  const phoneInput = useRef(null);
  const otpInput = useRef(null);

  const [errorInputName, setErrorInputName] = useState(null);

  useEffect(() => {
    if (errorInputName === "phone") {
      if (modalData.isOpen) {
        phoneInput.current.focus();
        setHasError(true);
      } else {
        setTimeout(() => {
          phoneInput.current?.focus();
          setHasError(true);
        }, 10);
      }
    }

    if (errorInputName === "otp") {
      if (modalData.isOpen) {
        otpInput.current.focus();
      } else {
        setTimeout(() => {
          otpInput.current?.focus();
        }, 10);
      }
    }

    setTimeout(() => {
      otpInput.current?.focus();
    }, 1000);
  }, [modalData.isOpen]);

  const handlePhoneBlur = () => {
    if (phone.trim() === "") {
      setHasError(true);
    } else {
      setHasError(!/^[6-9]\d{9}$/.test(phone));
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" || e.key === " " || e.key === "Enter") {
        if (modalData.isOpen) {
          // closeModal()
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [modalData.isOpen]);

  useEffect(() => {
    if (!isCheckingAuth) {
      phoneInput.current.focus();
    }
  }, [isCheckingAuth]);

  useEffect(() => {
    localStorage.removeItem("newNumber");
  }, []);

  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes = 120 seconds
  const [showRetry, setShowRetry] = useState(null);
  const [optList, setOTPList] = useState([]);

  useEffect(() => {
    let timer;

    if (timeLeft > 0) {
      setShowRetry(false); // Hide Retry button while countdown is active
      timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime === 1) {
            clearInterval(timer);
            setShowRetry(true); // Show Retry when timer hits 0
            setShowLoginBtn(true);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleRetry = () => {
    // Logic to resend OTP
    console.log("Resend OTP...");
    setTimeLeft(120);
    setShowRetry(false);

    btnGetOtp.current.click();
  };

  const invoiceData = {
    customer_id: "60045093060",
    invoice_number: "INV-000003",
    date: "2025-08-22",
    due_date: "2025-08-30",
    line_items: [
      {
        name: "Product A",
        description: "Sample product",
        rate: 1000,
        quantity: 1,
      },
      {
        name: "Service B",
        description: "Service charge",
        rate: 500,
        quantity: 2,
      },
    ],
    notes: "Thanks for your business",
    terms: "Payment due within 7 days",
    currency_id: "2882034000000000064",
  };

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get("access_token");
    const refresh = params.get("refresh_token");

    console.log(params);

    if (access && refresh) {
      localStorage.setItem("zoho_access_token", access);
      localStorage.setItem("zoho_refresh_token", refresh);
      alert("Token saved");
    }
  }, []);

  return (
    <>
      {isCheckingAuth ? (
        <div className="login-loader" />
      ) : (
        <div className={`claimpro-login ${darkMode ? "dark" : "light"}`}>
          {/* ================= TOP BAR ================= */}

          <header className="login-header">
            <div className="login-logo">
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png"
                alt="ClaimPro Assist"
              />
            </div>

            <div className="login-header-actions">
              <button
                onClick={() => navigate("/get-help")}
                className="help-button"
              >
                <Headphones size={16} />
                <span>Need Help?</span>
              </button>

              <button
                className="theme-toggle"
                onClick={() => setDarkMode(!darkMode)}
                aria-label="Toggle theme"
              >
                <span className={!darkMode ? "active" : ""}>
                  <Sun size={15} />
                </span>

                <span className={darkMode ? "active" : ""}>
                  <Moon size={15} />
                </span>
              </button>
            </div>
          </header>

          {/* ================= MAIN ================= */}

          <main className="login-main">
            {/* ================= LEFT HERO ================= */}

            <section className="login-hero">
              <div className="hero-content">
                <div className="hero-eyebrow">
                  <span />
                  CLAIMPRO ASSIST NETWORK
                </div>

                <h1
                  key={showEnglish ? "title-en" : "title-hi"}
                  className="hero-text-swap"
                  lang={showEnglish ? "en" : "hi"}
                >
                  {activeHero.titleLine1}
                  <br />

                  <span>{activeHero.titleLine2}</span>
                </h1>

                <p
                  key={showEnglish ? "sub-en" : "sub-hi"}
                  className="hero-subtitle hero-text-swap"
                  lang={showEnglish ? "en" : "hi"}
                >
                  {activeHero.subtitleLine1}
                  <br />
                  {activeHero.subtitleLine2}
                </p>

                {/* Services */}

                <div className="service-grid">
                  <div className="service-item">
                    <div className="service-icon">
                      <ShieldCheck size={19} />
                    </div>

                    <div>
                      <strong>Accident Support</strong>
                      <span>24/7 assistance</span>
                    </div>
                  </div>

                  <div className="service-item">
                    <div className="service-icon">
                      <Wrench size={19} />
                    </div>

                    <div>
                      <strong>Breakdown</strong>
                      <span>Quick assistance</span>
                    </div>
                  </div>

                  <div className="service-item">
                    <div className="service-icon">
                      <Construction size={19} />
                    </div>

                    <div>
                      <strong>Crane Service</strong>
                      <span>Heavy recovery</span>
                    </div>
                  </div>

                  <div className="service-item">
                    <div className="service-icon">
                      <LifeBuoy size={19} />
                    </div>

                    <div>
                      <strong>Recovery</strong>
                      <span>Roadside support</span>
                    </div>
                  </div>
                </div>

                {/* Network Status */}

                <div className="network-status">
                  <div className="network-dot" />

                  <div>
                    <strong>CLAIMPRO NETWORK</strong>

                    <span>24/7 roadside assistance across India</span>
                  </div>
                </div>
              </div>

              {/* Vehicle Image */}

              <div className="hero-image">
                <div className="hero-glow glow-one" />
                <div className="hero-glow glow-two" />

                <img
                  src={darkMode ? loginimage : loginimage2}
                  alt="ClaimPro roadside assistance"
                />
              </div>
            </section>

            {/* ================= LOGIN SIDE ================= */}

            <section className="login-side">
              <div className="login-card">
                {/* Card Header */}

                <div className="login-card-header">
                  <div className="welcome-label">WELCOME BACK</div>
                  <h2>Login to ClaimPro Assist</h2>
                  <p>Enter your mobile number to continue</p>
                </div>
                {/* Signup */}

                <div className="signup-text">
                  New to ClaimPro?
                  <Link to="/signUp">Create an account</Link>
                </div>

                {/* ================= PHONE ================= */}

                <div className="input-group">
                  <label>Mobile Number</label>

                  <div
                    className={`modern-input ${hasError ? "input-error" : ""}`}
                  >
                    <div className="country-code">+91</div>

                    <Phone size={17} />

                    <input
                      ref={phoneInput}
                      type="text"
                      id="phone"
                      name="phone"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      required
                      onChange={handlePhoneChange}
                      value={phone}
                      placeholder="Enter 10 digit mobile number"
                      maxLength={10}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (showLoginBtn) {
                            btnGetOtp.current.click();
                          } else {
                            btnLogin.current.click();
                          }

                          if (modalData.isOpen) {
                            closeModal();
                          }
                        }
                      }}
                    />
                  </div>

                  {phoneError && (
                    <div className="phone-error">{phoneError}</div>
                  )}
                </div>

                {/* ================= OTP ================= */}

                {!showLoginBtn && (
                  <div className="input-group otp-group">
                    <div className="otp-label-row">
                      <label>One-Time Password</label>

                      <span>6 digits</span>
                    </div>

                    <div
                      className={`modern-input ${
                        hasOtpError ? "input-error" : ""
                      }`}
                    >
                      <ShieldCheck size={18} />

                      <Input
                        disableUnderline
                        inputRef={otpInput}
                        className="otp-material-input"
                        placeholder="Enter OTP"
                        id="otp"
                        type={showPassword ? "text" : "password"}
                        value={otp}
                        onChange={handleOtpChange}
                        inputProps={{
                          maxLength: 6,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            if (showLoginBtn) {
                              btnGetOtp.current.click();
                            } else {
                              btnLogin.current.click();
                            }

                            if (modalData.isOpen) {
                              closeModal();
                            }
                          }
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle OTP visibility"
                              onClick={togglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>

                    <div className="otp-resend">
                      {showRetry ? (
                        <button onClick={handleRetry}>Resend OTP</button>
                      ) : (
                        <span>
                          Resend OTP in <strong>{formatTime(timeLeft)}</strong>
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* ================= POLICIES ================= */}

                <div className="policy-text">
                  <p>
                    By continuing, you agree to our{" "}
                    <span
                      onClick={() => {
                        window.open(
                          "/terms_&_condition",
                          "_blank",
                          "noopener,noreferrer",
                        );
                      }}
                    >
                      Terms & Conditions
                    </span>{" "}
                    and{" "}
                    <span
                      onClick={() => {
                        window.open(
                          "/privacy-policy",
                          "_blank",
                          "noopener,noreferrer",
                        );
                      }}
                    >
                      Privacy Policy
                    </span>
                  </p>

                  <p>
                    <span
                      onClick={() => {
                        window.open(
                          "/delete-account-page",
                          "_blank",
                          "noopener,noreferrer",
                        );
                      }}
                    >
                      Account Deletion Policy
                    </span>

                    {" • "}

                    <span
                      onClick={() => {
                        window.open(
                          "/cancellation-refund-policy",
                          "_blank",
                          "noopener,noreferrer",
                        );
                      }}
                    >
                      Cancellation & Refund
                    </span>
                  </p>
                </div>

                {/* ================= BUTTON ================= */}

                {showLoginBtn ? (
                  <button
                    ref={btnGetOtp}
                    onClick={getOtp}
                    className="login-submit"
                  >
                    {isLoading ? (
                      <span className="button-spinner" />
                    ) : (
                      <>
                        Get OTP
                        <ArrowRight size={18} />
                      </>
                    )}
                  </button>
                ) : (
                  <button
                    ref={btnLogin}
                    onClick={handleSubmit}
                    className="login-submit"
                  >
                    {isLoading ? (
                      <span className="button-spinner" />
                    ) : (
                      <>
                        Login
                        <ArrowRight size={18} />
                      </>
                    )}
                  </button>
                )}

                {/* Security */}

                <div className="security-note">
                  <ShieldCheck size={17} />

                  <span>Your information is securely encrypted</span>
                </div>
              </div>
            </section>
          </main>
        </div>
      )}
    </>
  );
}

export default Login;
